import React, { useEffect, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { Input } from "sr/helpers";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
export const JobPostNew = () => {
    const intl = useIntl()
    const [jobTypes, setJobTypes] = useState([])
    const [loader, setLoader] = useState(true)
            useEffect(()=>{
              const fetchJobType = async ()=>{
        try {
        const res = await getJobTypeCategory()
        if(res?.success===true){
          setLoader(false)
          setJobTypes(res?.data)
        }
        }
        catch(e:any){
        setLoader(false)
        }
              }
              fetchJobType()
            },[])
  return (
  <MainWrapper>
       <div className="py-3 lg:px-10 lg:max-w-4xl h-screen mx-auto">
        <div className="text-center lg:py-10 py-5">
            <p className="text-2xl "><FormattedMessage id="INDIVIDUAL.BOOKTASK.TITLE" defaultMessage="Book your Task" /></p>
        </div>
        <Input inputClass="border border-zinc-800 rounded-lg h-11" InputDivClass="mt-0" placeholder={intl.formatMessage({id:'INDIVIDUAL.BOOKTASK.INPUT.PLACEHOLDER', defaultMessage:'Describe one task'})}></Input>
       <ContentWithSpinner loader={loader} height="h-20">
        <div className="py-3 flex flex-wrap gap-x-3 justify-start">
            {jobTypes?.map((item, index)=> (
            <Link key={index} to={`/individual/job-post-details/${item?.value}`} className="hover:bg-[#595959] hover:text-white border border-gray-500 py-1 px-4 rounded-lg relative space-x-4 my-1.5 cursor-pointer"><FormattedMessage id={item?.label}/></Link>
            ))}
            </div>
            </ContentWithSpinner>
       </div>
  </MainWrapper>
  );
};
